export default __webpack_public_path__ + "static/media/sort-numeric-ascending-hover.1538add6.svg";